(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    function getRoot() {
      return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    }

    function redirectTo(url) {
      window.location.href = url;
    }

    function isVariantInCart(cart, variantId) {
      if (!cart || !cart.items || !cart.items.length) return false;
      var id = Number(variantId);
      return cart.items.some(function (item) {
        return Number(item.variant_id) === id || Number(item.id) === id;
      });
    }

    function addToCartThenRedirect(button, variantId, quantity, redirectUrl) {
      var root = getRoot();

      fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (isVariantInCart(cart, variantId)) {
            redirectTo(redirectUrl);
            return null;
          }

          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: quantity > 0 ? quantity : 1
                }
              ]
            })
          });
        })
        .then(function (response) {
          if (response === null) return null;
          return response.json().catch(function () {
            return {};
          }).then(function () {
            redirectTo(redirectUrl);
          });
        })
        .catch(function () {
          redirectTo(redirectUrl);
        });
    }

    function bindCustomCheckoutButtons() {
      var buttons = document.querySelectorAll('[data-iw-custom-checkout]');
      if (!buttons.length) return;

      buttons.forEach(function (button) {
        if (button.dataset.iwCustomCheckoutBound) return;
        button.dataset.iwCustomCheckoutBound = 'true';

        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (button.disabled) return;

          var form = button.closest('form');
          var variantInput = form ? form.querySelector('input[name="id"]') : null;
          var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;

          var variantId = variantInput && variantInput.value
            ? variantInput.value
            : button.getAttribute('data-variant-id');
          var quantity = quantityInput && quantityInput.value
            ? parseInt(quantityInput.value, 10)
            : 1;
          var redirectUrl = button.getAttribute('data-redirect-url');

          if (!variantId || !redirectUrl) return;

          button.disabled = true;
          addToCartThenRedirect(button, variantId, quantity, redirectUrl);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindCustomCheckoutButtons);
    } else {
      bindCustomCheckoutButtons();
    }

    document.addEventListener('shopify:section:load', bindCustomCheckoutButtons);
  })();
  } catch(e) { console.error(e); }
})();

})();
